import { Location } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { NavController, Platform } from '@ionic/angular';
import { register as RegisterSwiperElements } from 'swiper/element/bundle';
import { environment } from '../environments/environment';
import { ActivityService } from './services/activity.service';
import { AppVersionService } from './services/app-version.service';
import { DatabaseService } from './services/database.service';
import { FavIconService } from './services/favicon.service';
import { LoggingService } from './services/logging.service';
import { MobileLiveUpdateService } from './services/mobile-live-update.service';
import { NetworkService } from './services/network.service';
import { StoreTitleService } from './services/store-title.service';
import { UtilityService } from './services/utility.service';

RegisterSwiperElements();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  private faviconSubscription: any;
  constructor(
    private activityService: ActivityService,
    private platform: Platform,
    private location: Location,
    private navController: NavController,
    private networkService: NetworkService,
    private appVersionService: AppVersionService,
    private loggingService: LoggingService,
    private mobileLiveUpdateService: MobileLiveUpdateService,
    private databaseService: DatabaseService,
    private utilityService: UtilityService,
    private faviconService: FavIconService,
    private storeTitleService: StoreTitleService,
  ) {
    this.loggingService.disableConsoleLoggingInProduction();

    //Override hardware back button on Android devices
    this.platform.backButton.subscribeWithPriority(10, () => {
      console.log('Hardware back button called.');
      //Uncomment code below to use hardware back button to go back a page or exit the app
      if (this.location.isCurrentPathEqualTo('/home')) {
        App.exitApp();
      } else {
        this.navController.pop(); //Go back one page
      }
    });
  }

  async ngOnInit() {
    this.networkService.startMonitorNetwork();
    await this.mobileLiveUpdateService.initialize();
    this.appVersionService.initialize();
    if (environment.env !== 'dev' && !Capacitor.isNativePlatform()) {
      environment.rootDomainUrl = this.utilityService.getRootDomainUrl() + '/';
      environment.baseApiUrl = environment.rootDomainUrl + 'api/';
    }

    this.initialiseFavicon();
    this.initialiseStoreTitle();
  }

  async ngAfterViewInit() {
    await this.databaseService.initializeDatabase().then(async (result) => {
      if (result) {
        await this.databaseService.openDatabase();
      }
    });
  }

  async ngOnDestroy() {
    this.networkService.stopMonitorNetwork();
    await this.databaseService.closeDatabase();
    if (this.faviconSubscription) {
      this.faviconSubscription.unsubscribe();
    }
  }

  private initialiseFavicon() {
    this.faviconSubscription = this.faviconService.getStoreFavicon().subscribe((favicon) => {
      if (favicon) {
        this.faviconService.setStoreFavicon(favicon);
      }
    });
  }

  private initialiseStoreTitle() {
    this.storeTitleService.setStoreTitle();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e) {
    this.activityService.recordActivity();
  }

  @HostListener('document:click', ['$event'])
  onMouseClick(e) {
    this.activityService.recordActivity();
  }

  @HostListener('document:keyup', ['$event'])
  onKeyUp(e) {
    this.activityService.recordActivity();
  }

  @HostListener('document:touchstart', ['$event'])
  onTouchStart(e) {
    this.activityService.recordActivity();
  }
}
